var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { unwrap } from "survey-core";
import { SvgIcon, Popup, attachKey2click } from "survey-react-ui";
import { PageNavigatorViewModel } from "survey-creator-core";
import * as React from "react";
import { CreatorModelElement } from "./ModelElement";
var SurveyPageNavigator = /** @class */ (function (_super) {
    __extends(SurveyPageNavigator, _super);
    function SurveyPageNavigator(props) {
        var _this = _super.call(this, props) || this;
        _this.containerRef = React.createRef();
        return _this;
    }
    SurveyPageNavigator.prototype.createModel = function (props) {
        if (this.model) {
            this.model.dispose();
        }
        this.model = new PageNavigatorViewModel(props.pagesController, props.pageEditMode);
    };
    SurveyPageNavigator.prototype.getUpdatedModelProps = function () {
        return ["pagesController", "pageEditMode"];
    };
    SurveyPageNavigator.prototype.getStateElement = function () {
        return this.model;
    };
    SurveyPageNavigator.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        if (this.props.pageEditMode !== "bypage") {
            var el = this.containerRef.current;
            this.model.attachToUI(el);
        }
    };
    SurveyPageNavigator.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        this.model.stopItemsContainerHeightObserver();
        this.model.setScrollableContainer(undefined);
    };
    SurveyPageNavigator.prototype.renderElement = function () {
        var _this = this;
        var className = "svc-page-navigator__selector svc-page-navigator__button";
        if (this.model.isPopupOpened)
            className += " svc-page-navigator__button--pressed";
        return (React.createElement("div", { className: "svc-page-navigator", ref: this.containerRef, style: { display: this.model.visible ? "flex" : "none" } },
            React.createElement("div", null,
                attachKey2click(React.createElement("div", { role: "button", className: className, onClick: function () { return _this.model.togglePageSelector(); }, title: this.model.pageSelectorCaption },
                    React.createElement(SvgIcon, { className: "svc-page-navigator__button-icon", iconName: this.model.icon, size: "auto", title: this.model.pageSelectorCaption }))),
                React.createElement(Popup, { model: this.model.popupModel })),
            React.createElement("div", null, this.model.visibleItems.map(function (item) { return (React.createElement(SurveyPageNavigatorItem, { key: item.id, item: item })); }))));
    };
    return SurveyPageNavigator;
}(CreatorModelElement));
export { SurveyPageNavigator };
var SurveyPageNavigatorItem = /** @class */ (function (_super) {
    __extends(SurveyPageNavigatorItem, _super);
    function SurveyPageNavigatorItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SurveyPageNavigatorItem.prototype.getStateElement = function () {
        return this.props.item;
    };
    SurveyPageNavigatorItem.prototype.renderElement = function () {
        var item = this.props.item;
        var className = "svc-page-navigator-item-content";
        if (unwrap(item.active)) {
            className += " svc-page-navigator-item--selected";
        }
        if (unwrap(item.disabled)) {
            className += " svc-page-navigator-item--disabled";
        }
        return (React.createElement("div", { className: "svc-page-navigator-item" }, attachKey2click(React.createElement("div", { role: "button", className: className, onClick: function (e) {
                item.action(item);
                e.stopPropagation();
            } },
            React.createElement("div", { className: "svc-page-navigator-item__dot", title: item.title },
                React.createElement("div", { className: "svc-page-navigator-item__dot-content" })),
            React.createElement("div", { className: "svc-page-navigator-item__banner" },
                React.createElement("span", { className: "svc-page-navigator-item__text" }, item.title),
                React.createElement("span", { className: "svc-page-navigator-item__dot" },
                    React.createElement("span", { className: "svc-page-navigator-item__dot-content" })))))));
    };
    return SurveyPageNavigatorItem;
}(CreatorModelElement));
export { SurveyPageNavigatorItem };
